import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type ManageRoute from 'teacher-ui-client/manage/route'
import { RolloverLockOverlay } from 'teacher-ui-client/components/rollover/lock/overlay'

interface Signature {
  Args: {
    model: ModelFor<ManageRoute>
  }
}
export const ManagePage: TOC<Signature> = <template>
  <div class="relative w-full px-4">
    <RolloverLockOverlay />
    {{outlet}}
  </div>
</template>

export default RouteTemplate(ManagePage)
